import { Lesson, Absence, Bookable, Subject, Grade } from 'src/store/models/timetable/index.js'
import { LessonTeacher, TeacherSubject } from 'src/store/models/pivot/index.js'
import { CRUD } from 'src/store/models/helper/CRUD.js'
import Timetable from 'src/api/timetable.js'

export class Teacher extends CRUD {
  static entity = 'teachers'
  static fetchUrl = Timetable.timetableTeachersUrl()

  static fields () {
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      shortcut: this.attr(null),
      firstname: this.string(''),
      lastname: this.string(''),
      fullname: this.string(''),
      title: this.string('').nullable(),
      subjects: this.belongsToMany(Subject, TeacherSubject, 'teacher_id', 'subject_id'),
      no_substitution: this.boolean(false),
      no_supervision: this.boolean(false),
      main_room_id: this.attr(null),
      main_room: this.belongsTo(Bookable, 'main_room_id'),
      teacher_grade_id: this.attr(null),
      teacher_grade: this.belongsTo(Grade, 'teacher_grade_id'),
      teacher_co_grade_id: this.attr(null),
      teacher_co_grade: this.belongsTo(Grade, 'teacher_co_grade_id'),
      description: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      lessons: this.belongsToMany(Lesson, LessonTeacher, 'teacher_id', 'lesson_id'),
      absences: this.morphMany(Absence, 'target_id', 'target_type'),
      meta: this.attr({})
    }
  }
}

export default Teacher
